import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT, IDLE, PENDING } from "const"
import { StateType, hasProjectAccess } from "client/utils"
import {
    PRM_TEAM,
    StoreType,
    ProjectGroupProps,
    LoadProjectGroupById,
    setProjectGroupEdit,
    setProjectGroupReloadEdit,
    initProjectGroup,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    groupId = null,
}: ProjectGroupProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)

    const group = useSelector((state: StoreType) => state.projectGroup.groupEdit)
    const reloadEdit = useSelector((state: StoreType) => state.projectGroup.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setProjectGroupReloadEdit(false))
        setTimeout(() => {
            dispatch(setProjectGroupReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (groupId === 0) {
            dispatch(setProjectGroupEdit(initProjectGroup))
            reload()
        } else {
            setLoadState(PENDING)
            LoadProjectGroupById(groupId, project.accountId, project.id).then((res) => {
                dispatch(setProjectGroupEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    const editAccess = hasProjectAccess(PRM_TEAM, EDIT)
    const allowedToEdit = !group.default && editAccess

    let pageHeader = ""
    if (!group.groupId) pageHeader = lang.addGroup
    else if (allowedToEdit) pageHeader = `${lang.editGroup} # ${group.groupId}`
    else if (!allowedToEdit) pageHeader = `${lang.viewGroup} # ${group.groupId}`

    if (!group) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{pageHeader}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form group={group} editAccess={allowedToEdit} />
                }
                {
                    reloadEdit
                    && <Form group={group} editAccess={allowedToEdit} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
